import { Route } from "react-router-dom";
import MyShelfScreen from "./MyShelfScreen";
import LibraryScreen from "../library/LibraryScreen";
import PurchasesScreen from "../purchases/PurchasesScreen";

export const routes = (
  <Route path="my-shelf" Component={MyShelfScreen}>
    <Route path="library" Component={LibraryScreen} />
    <Route path="purchases" Component={PurchasesScreen} />
  </Route>
);
